// extracted by mini-css-extract-plugin
export default {"container":"style_container__QwpxJ","mobile":"style_mobile__EPivC","desktop":"style_desktop__Kgpbq"};